import { localizedMessagesService } from '@services/requests/localizedMessagesService';
import { LocalizedMessagesServiceInterfaces } from '@services/requests/localizedMessagesService/interfaces';
import { $error } from '@settings/errorContext';
import { graphQLClient } from '@settings/services/graphQLClient';
import { GraphQLClient } from '@settings/services/graphQLClient/GraphQLClient';

import {
  EcoFeePackagesLoaderParams,
  EcoFeePackagesLoaderQuery,
  EcoFeePackagesLoaderResponse,
} from './EcoFeePackagesLoaderQuery';
import {
  EcoFeeProductsLoaderParams,
  EcoFeeProductsLoaderQuery,
  EcoFeeProductsLoaderResponse,
} from './EcoFeeProductsLoaderQuery';
import { EcoFeeLoaderInterface } from './interface';

/**
 * Загрузчик данных по товарам и упаковкам экосбора
 */
export class EcoFeeLoader implements EcoFeeLoaderInterface {
  private readonly client: GraphQLClient;
  private readonly localizationLoader: LocalizedMessagesServiceInterfaces;

  constructor(token?: string) {
    this.client = graphQLClient(token);
    this.localizationLoader = localizedMessagesService(token);
  }

  // Загрузка данных продуктов экосбора
  async LoadProductsByParams(
    params: EcoFeeProductsLoaderParams
  ): Promise<EcoFeeProductsLoaderResponse['items']> {
    try {
      const resp = await this.client.Query<
        EcoFeeProductsLoaderParams,
        EcoFeeProductsLoaderResponse
      >(new EcoFeeProductsLoaderQuery(params), {});

      // Формируем общий список локализаций (ID)
      const localizedMessageIds = resp.items.reduce(
        (result: string[], item: EcoFeeProductsLoaderResponse['items'][number]): string[] => [
          ...result,
          ...item.localized_names,
        ],
        []
      );

      // Загружаем все локализованные тексты
      const messages = await this.localizationLoader.GetMessagesArray(localizedMessageIds);
      resp.items.map((item) => {
        item.localized_names_data = messages.filter(
          (m) => item.localized_names.indexOf(m.id) !== -1
        );
      });

      return resp.items;
    } catch (e) {
      $error.next(e);
    }
  }

  // Загрузка данных упаковок экосбора
  async LoadPackagesByParams(
    params: EcoFeePackagesLoaderParams
  ): Promise<EcoFeePackagesLoaderResponse['items']> {
    try {
      const resp = await this.client.Query<
        EcoFeePackagesLoaderParams,
        EcoFeePackagesLoaderResponse
      >(new EcoFeePackagesLoaderQuery(params), {});

      // Формируем общий список локализаций (ID)
      const localizedMessageIds = resp.items.reduce(
        (result: string[], item: EcoFeePackagesLoaderResponse['items'][number]): string[] => [
          ...result,
          ...item.localized_names,
        ],
        []
      );

      // Загружаем все локализованные тексты
      const messages = await this.localizationLoader.GetMessagesArray(localizedMessageIds);
      resp.items.map((item) => {
        item.localized_names_data = messages.filter(
          (m) => item.localized_names.indexOf(m.id) !== -1
        );
      });

      return resp.items;
    } catch (e) {
      $error.next(e);
    }
  }
}
